export default "__VITE_ASSET__CQUwEBzv__"